import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { WaiverCandidate } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

export interface WaiverCandidateFilters {
  searchTerm?: string;
  athleteStatus?: string;
  loginEnabled?: string;
  packages?: string[];
  hasPaymentMethod?: string;
  glmLinkState?: string;
}

export default function useWaiverCandidates(
  filters: WaiverCandidateFilters,
  options?: { enabled?: boolean },
): UseQueryResult<WaiverCandidate[]> {
  const params: UrlParams = {};
  if (filters.searchTerm) {
    params.search = filters.searchTerm;
  }
  if (filters.athleteStatus) {
    params.athlete_status = filters.athleteStatus;
  }
  if (filters.loginEnabled) {
    params.profile__login_enabled = filters.loginEnabled;
  }
  if (filters.packages && filters.packages.length > 0) {
    params.packages = filters.packages.join(',');
  }
  if (filters.hasPaymentMethod) {
    params.has_payment_method = filters.hasPaymentMethod;
  }
  if (filters.glmLinkState) {
    params.glm_link_state = filters.glmLinkState;
  }

  const fetchCandidates = (): Promise<WaiverCandidate[]> =>
    client
      .get<WaiverCandidate[]>(`athletes/waiver-candidates/?${encodeUrlParams(params)}`)
      .then(res => res.data);

  // Keyed on the params actually sent, so unrelated filter changes don't refetch.
  return useQuery(['waiver-candidates', params], fetchCandidates, {
    enabled: options?.enabled ?? true,
  });
}
